import { backendUrl } from "./backendUrl";

export const mediaUrl = (path) => {
  if (!path) return "";
  return /^https?:\/\//i.test(path) || path.startsWith("blob:") || path.startsWith("data:image/")
    || path.startsWith("/player-media/")
    ? path : `${backendUrl}${path}`;
};

export const formatDuration = (seconds) => {
  const value = Math.max(0, Math.round(Number(seconds) || 0));
  return `${Math.floor(value / 60)}:${String(value % 60).padStart(2, "0")}`;
};

export const formatBytes = (bytes) => {
  const value = Number(bytes) || 0;
  if (value < 1024) return `${value} B`;
  if (value < 1024 * 1024) return `${Math.round(value / 1024)} KB`;
  return `${(value / 1024 / 1024).toFixed(1)} MB`;
};
